"use client";

import { useEffect, useState } from "react";

// Returns `value` delayed by `delayMs`, so expensive work keyed off a fast-changing input
// (e.g. an every-keystroke text field) runs only after typing pauses instead of on each character.
export function useDebounced<T>(value: T, delayMs = 300): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(t);
  }, [value, delayMs]);
  return debounced;
}
